import {
  PageContentContainer,
  PageLoading,
} from "@fp/ui/components/base/page-layout/page-layout";
import { AdminLayout } from "@/components/admin-layout";
import { AdminPageHeader } from "@/components/admin-page-header";
import { createFileRoute } from "@tanstack/react-router";
import { useListReceivables } from "@fp/admin-api-client/receivables/receivables.client";
import { ReceivableRow } from "@/components/funding/receivable-row";

export const Route = createFileRoute("/funding/receivables/")({
  component: RouteComponent,
  pendingComponent: () => <PageLoading />,
});

function RouteComponent() {
  const { data: response, isLoading } = useListReceivables();
  const receivables = response?.data ?? [];

  return (
    <AdminLayout isWide>
      <AdminPageHeader
        title="Receivables"
        parent={{ url: "/funding", label: "Funding" }}
      />
      <PageContentContainer>
        {isLoading ? (
          <PageLoading />
        ) : receivables.length > 0 ? (
          <div className="bg-white border border-gray-200 rounded-lg divide-y divide-gray-200">
            {receivables.map((receivable) => (
              <ReceivableRow key={receivable.id} receivable={receivable} />
            ))}
          </div>
        ) : (
          <div className="text-center text-gray-500 py-8">No organization has created a payout to you yet</div>
        )}
      </PageContentContainer>
    </AdminLayout>
  );
}
